module.exports = __webpack_public_path__ + "img/大圈.f2768810.png";